import { render } from "./TermoUsoComp.vue?vue&type=template&id=72a9d93f&scoped=true"
import script from "./TermoUsoComp.vue?vue&type=script&lang=js"
export * from "./TermoUsoComp.vue?vue&type=script&lang=js"

import "./TermoUsoComp.vue?vue&type=style&index=0&id=72a9d93f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a9d93f"]])

export default __exports__